












































import {getFileNameFromUrl, getViewerUrl} from "@/set/search/setSearch";
import {SetState} from "@/set/set_store";
import {PropType} from "@vue/composition-api";
import Vue from 'vue'
import {mapMutations, mapState} from "vuex";

export default Vue.extend({
  props: {
    hrefs: Array as PropType<string[]>
  },
  data() {
    return {
      src: {
        main: this.hrefs[0],
        sub: this.hrefs[1]
      }
    }
  },
  mounted() {
    this.setDefaultSrcs()
  },
  methods: {
    ...mapMutations('set', ['toggleMode', 'decreaseRatio', 'increaseRatio', 'toggleEngine']),
    setDefaultSrcs(){
      //set default docs to show
      const financial = this.hrefs.find(x => x.match(/FINANCIAL_STATEMENTS/))
      if (financial) {
        this.src.main = financial
      } else {
        console.error('cannot find "FINANCIAL_STATEMENTS" from %o', this.hrefs)
        this.src.main = this.hrefs[0]
      }
      const notes = this.hrefs.find(x => x.match(/NOTES/))
      if (notes) {
        this.src.sub = notes
      } else {
        console.error('cannot find "NOTES" from %o', this.hrefs)
        this.src.sub = this.hrefs[0]
      }
    },
    getFileNameFromUrl: getFileNameFromUrl,
    customStyle(main: boolean): string {
      if (this.viewerConfig.split) {
        const size = main ? this.viewerConfig.splitRatio : 100 - this.viewerConfig.splitRatio
        return `${(this.viewerConfig.splitMode === 'vertical') ? 'height' : 'width'}:${size}%`
      } else {
        return 'width: 100%; height: 100%'
      }
    }
  },
  computed: {
    ...mapState('set', {
      'viewerConfig': state => (state as SetState).viewerConfig
    }),
    splitIcon(): string {
      return (this.viewerConfig.splitMode === 'vertical') ? '—' : '|'
    },
    mainSrcViewerUrl(): string {
      const url = getViewerUrl(this.src.main, this.viewerConfig.engine)
      return url
    },
    subSrcViewerUrl(): string {
      return getViewerUrl(this.src.sub, this.viewerConfig.engine)
    }
  },
  watch: {
    hrefs() {
      this.setDefaultSrcs()
    }
  }
})
